import React from "react";
import { Typography, Box } from "@material-ui/core";
import { useStyles } from "styling/mainStyles";
import { LanguageList } from "components/common";

export const PageHeading = ({ children, ...rest }) => {
  const classes = useStyles();

  return (
    <Box className={classes.pageHeading}>
      <Box className="language-list">
        <LanguageList />
      </Box>
      <Typography variant="h4" color="primary" {...rest}>
        {children}
      </Typography>
    </Box>
  );
};
